import { render } from "./RiskSelector.vue?vue&type=template&id=b5bda4de&scoped=true&ts=true"
import script from "./RiskSelector.vue?vue&type=script&lang=ts"
export * from "./RiskSelector.vue?vue&type=script&lang=ts"

import "./RiskSelector.vue?vue&type=style&index=0&id=b5bda4de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5bda4de"]])

export default __exports__